export default __webpack_public_path__ + "Roboto-Light.ttf?333da16a3f3cc391d0876c6d773efc6f";